<script>
    import Home from "./routes/Home.svelte";
    import About from "./routes/About.svelte";
    import Share from "./routes/Share.svelte"

    import { Router, Link, Route } from "svelte-routing";
    // import { SvelteToast } from '@zerodevx/svelte-toast'
    import {notifications} from './components/notifications.js'
	import Toast from './components/Toast.svelte'

    export let url = "";

    const options = {
        theme: {
            '--toastBackground': 'cyan',
            '--toastColor': 'black',
            '--toastContainerTop': 'unset',
            '--toastContainerBottom': '1rem',
        }
    }

</script>

<Router url="{url}">
        <Route path="about" component="{About}" />
        <Route path="/"><Home /></Route>
        <Route path="share/:id" let:params>
            <Share shareSlug="{params.id}" />
        </Route>
</Router>
<!-- <SvelteToast {options} /> -->

<Toast />

